var Link_INCI = {
    init:function(){
        $(".meta.inci a").on("click touchend", function(e){

            e.preventDefault();
            e.stopPropagation();

            if(e.type == "touchend"){
                $(this).off("click");
            }

            var _href = $(this).attr("href");
            console.log("CLICK INCI : " + _href);

            window.open(_href, '_blank').focus();

        })
    }
}

$(window).on("load", function(){
   if($(".meta.inci").length){
       Link_INCI.init();
   }
});